import React, { useState } from 'react';
import { Mail, Copy, Check, X } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

export default function SupportEmailPopup({ open, onClose }) {
  const [copied, setCopied] = useState(false);
  const email = 'support@razientsounds.com';

  const handleCopy = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      toast.success('Email copied!');
      setTimeout(() => setCopied(false), 2000);
    });
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div
        className="relative w-full max-w-md mx-4 p-8 rounded-2xl bg-gray-900 border border-white/10 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="support-email-popup"
      >
        <button onClick={onClose} className="absolute top-4 right-4 text-white/40 hover:text-white" data-testid="close-popup">
          <X className="w-5 h-5" />
        </button>

        <div className="text-center">
          <div className="w-16 h-16 rounded-full bg-violet-500/20 flex items-center justify-center mx-auto mb-4">
            <Mail className="w-8 h-8 text-violet-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Contact Support</h2>
          <p className="text-white/50 text-sm mb-6">Send us an email and we'll get back to you as soon as possible</p>

          <div
            className="relative rounded-xl p-4 mb-5"
            style={{
              background: 'rgba(168, 85, 247, 0.08)',
              border: '1px solid rgba(168, 85, 247, 0.25)',
              boxShadow: '0 0 20px rgba(168, 85, 247, 0.15)'
            }}
          >
            <p
              className="text-lg font-semibold tracking-wide"
              style={{
                color: '#c084fc',
                textShadow: '0 0 10px rgba(192, 132, 252, 0.6), 0 0 20px rgba(168, 85, 247, 0.4)'
              }}
              data-testid="support-email-text"
            >
              {email}
            </p>
          </div>

          <Button
            onClick={handleCopy}
            data-testid="copy-support-email-btn"
            className={`w-full h-12 rounded-full font-semibold transition-all duration-300 ${
              copied
                ? 'bg-green-600 hover:bg-green-500 shadow-[0_0_20px_rgba(34,197,94,0.4)]'
                : 'bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-500 hover:to-indigo-500 shadow-[0_0_20px_rgba(139,92,246,0.4)]'
            }`}
          >
            {copied ? <><Check className="mr-2" size={18} /> Copied!</> : <><Copy className="mr-2" size={18} /> Copy Email Address</>}
          </Button>
        </div>
      </div>
    </div>
  );
}
